<button mat-raised-button
  [disabled]="isFullTextSearch"
  color="primary"
  (click)="addFiles()">
  {{'COMMON.LABEL.ADD_FILES' | translate}}
</button>